import React from 'react';

type SEOLinksProps = {
  categories?: SEOLinkItem[];
};

type SEOLinkItem = {
  name?: string;
  url?: string;
  child?: SEOLinkItem[];
};

export const SEOLinks = ({ categories = [] }: SEOLinksProps) => {
  const mapCategory = (category?: SEOLinkItem[]) =>
    category?.map(({ name, url, child }) => (
      <React.Fragment key={name}>
        {url && <a href={url}>{name}</a>}
        {child?.length > 0 && mapCategory(child)}
      </React.Fragment>
    )) || [];

  return (
    <div data-testid="navigation-menu-links" style={{ display: 'none' }}>
      {categories?.length > 0 && mapCategory(categories)}
    </div>
  );
};
